import { AttributionService, getObAwareInternalUrl } from '@web_opxp/features';
import { HistoryService, isRequestAbortedError } from 'web_core_library';
import { EAppRoutes, EEvaluationRoutes } from '../routes';
import blogUrls from './blogUrls.json';
import { BlogBaseUrl, MobileAppLink, PrivacyPolicyUrl, SubscribeBaseUrl } from './env';

export enum EBlogUrls {
  Blog = 'blog',
  Studies = 'studies',
  Projects = 'projects',
  Effectiveness = 'effectiveness',
  Extra1 = 'extra1',
  Extra2 = 'extra2',
  Extra3 = 'extra3',
  Extra4 = 'extra4',
  Extra5 = 'extra5',
}

export function isFetchErrorCanBeSkipped(error: any) {
  return isRequestAbortedError(error);
}

export const getBlogPage = (lang?: string, path = EBlogUrls.Blog) => {
  let blogPath = '';
  switch (lang) {
    case 'en':
      blogPath = blogUrls[path].en;
      break;
    case 'de':
      blogPath = blogUrls[path].de;
      break;
    case 'fr':
      blogPath = blogUrls[path].fr;
      break;
    case 'ru':
      blogPath = blogUrls[path].ru;
      break;
  }
  const blogUrl = new URL(`${BlogBaseUrl}${blogPath}`);
  AttributionService.updateSearchParams(blogUrl.searchParams);
  return blogUrl.toString();
};

export const getWelcomeLink = (location?: Location) => getObAwareInternalUrl('/', location?.search);

export const getAssessmentUrl = () => {
  return HistoryService.getInternalUrl('/assessment');
};

export const redirectToAssessment = () => HistoryService.redirectInternal(getAssessmentUrl());

export const redirectToEvaluation = (page = `/${EAppRoutes.Evaluation}${EEvaluationRoutes.Intro}`) => {
  HistoryService.redirectInternal(page, {}, HistoryService.getCurrentSearchParams().toString());
};

export const getPrivacyPolicyUrl = () => {
  return HistoryService.getInternalUrl(PrivacyPolicyUrl);
};

export const stripLastSlash = (str: string) => {
  return str.replace(/\/$/, '');
};

export const getStudiesUrl = (lang: string) => getBlogPage(lang, EBlogUrls.Studies);
export const getProjectsUrl = (lang: string) => getBlogPage(lang, EBlogUrls.Projects);

export const getPersonalization = () => {
  const searchParams = HistoryService.getCurrentSearchParams();
  return searchParams.has('p13n');
};

export const isLumosityHome = (pathname?: string) => {
  const currentPath = pathname ?? HistoryService.getLocation().pathname;
  return stripLastSlash(currentPath) === '/lp/go';
};

export const getCorpSubpage = (pathname?: string) => {
  const currentPath = pathname ?? HistoryService.getLocation().pathname;
  switch (stripLastSlash(currentPath)) {
    case '/lp/corp/science':
      return 'science';
    case '/lp/corp/exercises':
      return 'exercises';
    default:
      return 'home';
  }
};

export const getLumositySubpage = (pathname?: string) => {
  const currentPath = pathname ?? HistoryService.getLocation().pathname;
  switch (stripLastSlash(currentPath)) {
    case '/lp/go/science':
      return 'science';
    case '/lp/go/exercises':
      return 'exercises';
    default:
      return 'home';
  }
};

export const getLPLocaId = (search?: string) => {
  const searchParams = HistoryService.getCurrentSearchParams(search);
  return searchParams.get('loca');
};

export const getSubscribeUrl = (lang?: string, session?: string, coupon?: string) => {
  let subscribeUrl = SubscribeBaseUrl;
  if (coupon) {
    subscribeUrl = `${SubscribeBaseUrl}/?coupon=${coupon}`;
  }
  return HistoryService.getExternalUrl(subscribeUrl, lang, session);
};

export function redirectMobileStore() {
  // BW-9442 we do not use history service here to prevent the link from unwanted modifications
  return window.location.assign(MobileAppLink);
}

export const getRecruitmentLink = () => {
  const blogUrl = new URL('/de/studienteilnehmer-innen-fuer-studie-gesucht/', BlogBaseUrl);
  AttributionService.updateSearchParams(blogUrl.searchParams);
  return blogUrl.toString();
};

export const getMedRecruitmentLink = () => {
  const medUrl = new URL(
    'https://neuronation-med.de/?utm_source=neuronation&utm_medium=banner&utm_campaign=top-banner'
  );
  // attribution can be added here if needed
  return medUrl.toString();
};
